import Pagination from "react-js-pagination";
import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment";
import { open, close } from "../redux/popupSlice";

import routes from '../libs/routes';
import images from "../libs/images";
import * as API from "../libs/service";

import Popup01 from "../pages/popup/Popup01"
import PopupPlusMember from "../pages/popup/PopupPlusMember"
import PopupLicensing from "../pages/popup/PopupLicensing"
import Licensing from "../pages/mypage/Licensing";
import { loadingStart, loadingEnd } from "../redux/loadingSlice";
import { refreshLicenseData } from "../libs/utils";


export default function PaginationSetLicense(props) {
    const {
        coupon,
        setSelectedItems,
        modifyLicense,
        chkReset,
        searchTeam,
        searchWord,
        licenseType,
        license
    } = props

    const dispatch = useDispatch();

    const { mbData } = useSelector(s => s.usersReducer);

    const pro = useSelector((s) => s.licenseReducer.pro);
    const art = useSelector((s) => s.licenseReducer.art);
    const all = useSelector((s) => s.licenseReducer.all);
    const lang = useSelector(state => state.langReducer.lang);

    console.log("licenseType : ", licenseType);
    const licenseList = licenseType === 0 ? pro : licenseType === 1 ? art : all;

    const organization = useSelector((s) => s.licenseReducer.organization);
    const dataList = coupon || organization.users;

    const [checkboxStates, setCheckboxStates] = useState(new Array(dataList.length).fill(false));
    const [isAllChecked, setIsAllChecked] = useState(false);

    const per_sample = ['User', 'Manager', 'Owner', 'User', 'Manager', 'Owner', 'User', 'Manager', 'Owner', 'User', 'Manager', 'Owner'];
    const state_sameple = ['활성', '비활성', '만료', '할당', '활성', '비활성', '만료', '할당', '활성', '비활성', '만료', '할당', '활성', '비활성', '만료', '할당'];

    const [page, setPage] = useState(1);

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const itemsPerPage = 5;
    const indexOfLastItem = page * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const Items = dataList.slice(indexOfFirstItem, indexOfLastItem);


    function findTeamNameForUser(userId) {
        if (!organization.teams || organization.teams.length === 0) {
            return '';
        }

        for (const team of organization.teams) {
            if (team.members && team.members.some(member => member.user && member.user.id === userId)) {
                return team.name;
            }
        }
        return '';
    }

    const matchingTeam = organization.teams.find(team => team.name === searchTeam);

    let users = [];
    if (!searchTeam || searchTeam === '조직 전체') {
        users = organization.users;
    } else {
        const matchingTeam = organization.teams.find(team => team.name === searchTeam);
        if (matchingTeam && matchingTeam.members && matchingTeam.members.length > 0) {
            users = matchingTeam.members.map(member => member.user);
        }
    }

    if (searchWord && searchWord.trim().length > 0) {
        const lowerSearch = searchWord.toLowerCase();
        users = users.filter(user =>
            (user.email && user.email.toLowerCase().includes(lowerSearch)) ||
            (user.fullname && user.fullname.toLowerCase().includes(lowerSearch))
        );
    }

    console.log("users : ", users, ", licenseList : ", licenseList);
    users = users.map(user => {
        console.log("user : ", user);
        return {
            ...user,
            isDisabled: licenseList.some(lic => {
                console.log("lic : ", lic);
                console.log("user.id : ", user);
                return lic.user?.id === user.id;
            })
        };
    });

    console.log("users: ", users);


    return (
        <div className="PaginationContent">
            <div className="my_coupon_list_box page_set_license" style={{ marginTop: '0' }}>
                {dataList ?
                    <>
                        {/* <div className={`my_coupon_info license_use`}>
                            <p className="top80">개발1팀</p>
                            <p className="top120">이름</p>
                            <p className="top220">aiffasf@naver.com</p>
                            <p className="sel top64">사용중</p>
                        </div> */}

                        {users.map((x, i) => (
                            <div key={x} style={{ justifyContent: 'left', flexDirection: 'row', display: 'flex', width: '100%', height: 52, alignItems: 'center', borderBottom: '1px solid #E5E5E5' }}>
                                <p className="top80" style={{ flex: 0.3, color: x.isDisabled ? '#999999' : '#121316', textAlign: 'left' }}>{findTeamNameForUser(x.id)}</p>
                                <p className="top120" style={{ flex: 0.3, color: x.isDisabled ? '#999999' : '#121316', textAlign: 'left' }}>{x.fullname}</p>
                                <p className="top220" style={{ flex: 1, textAlign: 'left', color: x.isDisabled ? '#999999' : '#121316', textAlign: 'left' }}>{x.email}</p>
                                <p
                                    className="sel top64"
                                    style={{ width: '70px', color: x.isDisabled ? '#999999' : '#0E6AF4' }}
                                    onClick={() => {
                                        if (x.isDisabled) return;
                                        dispatch(open({
                                            component:
                                                <Popup01
                                                    max_width={'300px'}
                                                    x_btn={false}
                                                    text1={'라이선스를 할당하시겠습니까?'}
                                                    button={'네'}
                                                    buttonCancel={'아니오'}
                                                    setFunc={async () => {
                                                        dispatch(loadingStart());
                                                        let sender = {
                                                            licenseId: license.id,
                                                            userId: x.id,
                                                        };
                                                        console.log("sender : ", sender);
                                                        const result = await API.patch('license/assign', sender )
                                                        console.log("result : ", result);
                                                        if (result.status === 200) {
                                                            refreshLicenseData(dispatch, mbData.idx);
                                                            dispatch(close());
                                                            dispatch(loadingEnd());
                                                            dispatch(open({
                                                                component:
                                                                    <Popup01
                                                                        max_width={'300px'}
                                                                        x_btn={false}
                                                                        text1={'할당되었습니다.'}
                                                                        longButton={lang === 0 ? '확인' : 'OK'}
                                                                    />
                                                            }));
                                                        }
                                                        // setTimeout(() => {
                                                        //     dispatch(open({
                                                        //         component:
                                                        //             <Popup01
                                                        //                 max_width={'300px'}
                                                        //                 x_btn={false}
                                                        //                 text1={'할당되었습니다.'}
                                                        //                 longButton={'확인'}
                                                        //             />
                                                        //     }));
                                                        //     dispatch(loadingEnd());
                                                        // }, 1000);
                                                    }}
                                                />
                                        }));
                                    }}
                                >
                                    {x.isDisabled ? '사용중' : '선택'}
                                </p>
                            </div>
                        ))}

                        {/* <div className={`my_coupon_info`}>
                            <p>aiffasf@naver.com</p>
                            <p>이름입니다</p>
                            <p className="license_off">
                                비활성
                            </p>
                            <p className="member_set">
                                <span
                                    onClick={() => {
                                        MeberSetFunc()
                                    }}
                                >
                                    관리
                                </span>
                            </p>
                        </div> */}
                    </>
                    :
                    <p className="not_coupon">결제 내역이 없습니다.</p>
                }

            </div>

            <Pagination
                className="my-pagination"
                // 현재 보고있는 페이지
                activePage={page}
                // 한페이지에 출력할 아이템수
                itemsCountPerPage={5}
                // 총 아이템수
                totalItemsCount={dataList.length || 1}
                // 표시할 페이지수
                pageRangeDisplayed={10}
                // 함수
                onChange={handlePageChange}
                nextPageText={<img src={require("../assets/icon/page_right.svg").default} />}
                prevPageText={<img src={require("../assets/icon/page_left.svg").default} />}
                firstPageText={<img src={require("../assets/icon/page_left_set.svg").default} />}
                lastPageText={<img src={require("../assets/icon/page_right_set.svg").default} />}
            ></Pagination>
        </div>
    )
}